import { createContext, useContext, useState, ReactNode } from 'react';
import { IOfferContractsWithProductSeats } from '../../_models/offer-contracts-with-product';
import { IProductGroup } from '../../_models/product-group';
import { ProposalStateEnum } from '../../_enums/proposal-state';

interface iSalesOfferContext {
  formData: {
    cart: IProductGroup[];
    contract: IOfferContractsWithProductSeats | null;
    noteToCustomer: string;
    noteFromCustomer: string;
    internalNote: string;
    customerCart: IProductGroup[];
    customerEmails: string[];
    companyNumber: string;
    expirationDate: Date;
    proposalNumber: string;
    state: ProposalStateEnum;
    salesAgent: {
      email: string,
      name: string,
      phoneNumber: string,
      profilePictureUrl: string,
      companyName: string,
      companyNumber: string,
      orgNr: string
    }
  };
  updateFormData: (field: keyof iSalesOfferContext['formData'], value: any) => void;
}

const SalesOfferContext = createContext<iSalesOfferContext | undefined>(undefined);

export const SalesOfferProvider = ({
  children,
  initialState,
}: {
  children: ReactNode;
  initialState: iSalesOfferContext['formData'];
}) => {
  const [formData, setFormData] = useState<iSalesOfferContext['formData']>(initialState);

  const updateFormData = (field: keyof iSalesOfferContext['formData'], value: any) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <SalesOfferContext.Provider value={{ formData, updateFormData }}>
      {children}
    </SalesOfferContext.Provider>
  );
};

export const useSalesOfferContext = () => {
  const context = useContext(SalesOfferContext);
  if (!context) {
    throw new Error("useSalesOfferContext must be used within a SalesOfferProvider");
  }
  return context;
};
